import React from 'react'

import { Button, Emoji } from '@fourthwall/components'

import * as S from './SuccessStage.styled'

export type IntroStageProps = {
  onOrderSamples: () => void
  onClaimFreeDomain: () => void
  onClose: () => void
}

export const SuccessStage = ({ onClaimFreeDomain, onOrderSamples, onClose }: IntroStageProps) => {
  return (
    <S.Content>
      <S.Text>
        You’ve unlocked powerful tools to grow your brand like never before. Let’s build something
        amazing together. <Emoji shortcode="rocket" />
      </S.Text>
      <S.Text>Start with Fourthwall Pro’s top feature: a free custom domain just for you:</S.Text>
      <S.ButtonsContainer>
        <Button
          label="Claim free domain"
          appearance="primary"
          fullWidth
          onClick={onClaimFreeDomain}
        />
        <Button label="Order samples" appearance="secondary" fullWidth onClick={onOrderSamples} />
        <Button label="Back to dashboard" appearance="secondary" fullWidth onClick={onClose} />
      </S.ButtonsContainer>
    </S.Content>
  )
}
